/** @format */
import { Injectable } from '@angular/core';
import { EntityStore, QueryEntity, StoreConfig } from '@datorama/akita';
import { NgEntityServiceConfig } from '@datorama/akita-ng-entity-service';
import { EntityService } from '../service/entity.service';

const url = '/arto/api/feedback/answer';

@Injectable({ providedIn: 'root' })
@NgEntityServiceConfig({
    baseUrl: url,
})
export class FeedbackService extends EntityService<any> {
    constructor() {
        super(FeedbackStore, FeedbackQuery);
    }

    postAnswer(rating: number) {
        return this.getHttp().post(url, { rating });
    }
}

// Stale store and query classes appear to be necessary to be able to leverage,
// `NgEntityServiceConfig`, but these are currently not used for anything.

@StoreConfig({ name: 'feedback' })
class FeedbackStore extends EntityStore {}

class FeedbackQuery extends QueryEntity<undefined> {
    constructor(protected store: FeedbackStore) {
        super(store);
    }
}
